<template>
  <v-container
    id="containerTable"
    fluid
    class="page-section pa-0 fill-height"
    style="position: relative;"
  >
    <v-card class="card-toolbar" min-width="100%" flat tile>
      <v-toolbar flat>
        <v-toolbar-title>{{ parseSlugModule(typeSubmodule) }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <judicial-process-drawer
      ref="judicialDrawer"
      @filter="onSearchFilter"
    ></judicial-process-drawer>
    <div class="content-table-module">
      <v-row
        class="fill-height"
        style="padding: 0 12px 0 12px; position: relative;"
      >
        <vue-perfect-scrollbar
          ref="perfectScrollbar"
          style="width: 100%;"
          class="content-meta-scroll"
          :settings="scrollModuleSettings"
          :swicher="loadData"
          @ps-scroll-y="onScrollY($event, true)"
          @ps-y-reach-end="scrollHanle"
        >
          <v-col cols="12">
            <v-card elevation="7" style="overflow:hidden;">
              <v-toolbar flat dense color="transparent">
                <v-toolbar-title><h4>Proceso judicial</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <export-excel
                  :api-module="apiByModule"
                  :filter-data="filterData"
                  :sort-items="sortJudicialProcess"
                ></export-excel>
                <template
                  v-if="roleUser !== 'visualizer' && roleUser !== 'executor'"
                >
                  <v-btn
                    class="btn-transform-none ml-2"
                    color="primary"
                    small
                    depressed
                    @click="openDialogUpdate('add')"
                  >
                    <v-icon>add</v-icon>
                    Agregar Proceso Judicial
                  </v-btn>
                </template>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="pa-0">
                <v-data-table
                  :headers="configHeader"
                  :items="listItem"
                  :loading="!loadData"
                  :items-per-page="-1"
                  hide-default-footer
                  item-key="id"
                  class="table-striped"
                  @update:sort-by="eventSortBy"
                  @update:sort-desc="eventSortDesc"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <template v-if="!noResult && loadData">
                        <tr
                          v-for="(item, index) in items"
                          :id="item.id"
                          :key="item.id"
                        >
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{ item.file_code }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{ item.complaining_party }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{ item.respondent_party }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{ item.cargo_study.label }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{
                              item.responsible
                                ? `${item.responsible.first_name} ${item.responsible.last_name}`
                                : "---"
                            }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{
                              item.secondary_responsible
                                ? `${item.secondary_responsible.first_name} ${item.secondary_responsible.last_name}`
                                : "---"
                            }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{ item.controversial_matter }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{ item.amount }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            {{ item.project.label }}
                          </td>
                          <td
                            class="td-hover"
                            @click="openDialogUpdate('edit', item, index)"
                          >
                            <v-chip variant="flat" color="secondary" v-show="item.stage === 0">No iniciado</v-chip>
                            <v-chip variant="flat" color="primary" v-show="item.stage === 1">Primera Instancia</v-chip>
                            <v-chip variant="flat" color="primary" v-show="item.stage === 2">Segunda Instancia</v-chip>
                            <v-chip variant="flat" color="primary" v-show="item.stage === 3">Casación</v-chip>
                          </td>
                          <td
                            v-if="
                              roleUser !== 'visualizer' &&
                                roleUser !== 'executor'
                            "
                            class="text-center"
                          >
                            <v-btn
                              small
                              icon
                              depressed
                              @click="openDialogDelete(item, index)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <tr v-if="noResult" class="v-data-table__empty-wrapper">
                        <td :colspan="headers.length">
                          No se encontró resultados
                        </td>
                      </tr>
                      <tr
                        v-if="!loadData && !noResult"
                        class="v-data-table__empty-wrapper"
                      >
                        <td :colspan="headers.length">
                          Esperando resultados
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            v-if="loadScroll && loadData"
            cols="12"
            class="pt-2 pb-1 text-center"
          >
            <v-progress-circular
              :size="20"
              class="d-inline-block mr-3"
              :width="2"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <span class="d-inline-block primary--text caption"
              >Cargando más registros</span
            >
          </v-col>
          <v-col
            v-if="isFinishedScroll && loadData && !noResult"
            cols="12"
            class="pt-2 pb-1 text-center"
          >
            <span class="caption">No hay más registros.</span>
          </v-col>
        </vue-perfect-scrollbar>
        <module-detail-table
          v-if="loadData"
          class="type-submodule"
          :meta-data="metaData"
          :is-todo="true"
          :total-count="totalCount"
        ></module-detail-table>
      </v-row>
    </div>
    <!-- Modal Judicial Processes -->
    <dialog-detail-base-process
      ref="dialogDetailCard"
      v-model="dialogNew"
      :type-dialog="typeDialog"
      :type-module="typeModule"
      :type-submodule="typeSubmodule"
      @create-active="onActiveNewItem"
      @close="onCloseDetailCard"
      @re-fetch="reFetch"
    ></dialog-detail-base-process>

    <dialog-delete
      ref="dialogDelete"
      v-model="dialogDelete"
      title="Eliminar ficha"
      :is-module="true"
      :item="selectedItem"
      @delete="onSubmitDelete"
    ></dialog-delete>
  </v-container>
</template>
<script>
import { IJudicialProcess } from "@/models";
import { mapActions, mapState } from "vuex";
import { cloneDeep, uniqBy } from "lodash";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import mixinSort from "@/components/judicialprocess/mixins/mixinSort";
import mixinApiModule from "@/components/modules/mixins/mixinApiModule";
import JudicialProcessDrawer from "@/components/judicialprocess/JudicialProcessDrawer";
import ExportExcel from "@/components/commons/ExportExcel";
import ModuleDetailTable from "@/components/commons/ModuleDetailTable";
import DialogDetailBaseProcess from "@/components/judicialprocess/DialogDetailBaseProcess";
import DialogDelete from "@/components/commons/DialogDelete";

export default {
  name: "JudicialProcessPage",
  components: {
    VuePerfectScrollbar,
    ExportExcel,
    DialogDetailBaseProcess,
    ModuleDetailTable,
    JudicialProcessDrawer,
    DialogDelete,
  },
  mixins: [mixinSort, mixinApiModule],
  props: {
    fichaId: {
      type: String,
      default: "",
    },
    typeModule: {
      type: String,
      default: "",
    },
    typeSubmodule: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isEditable: false,
    activeTab: 1,
    loadSave: false,
    showBtnInfo: false,
    showStepOne: true,
    showStepTwo: false,
    disabledStepTwo: true,
    showStepThree: false,
    disabledStepThree: true,
    enabledDate: false,
    optionProcess: null,
    checkAppeal: false,
    enabledDateAppeal: false,
    dialogEditActa: false,
    scrollModuleSettings: { maxScrollbarLength: 160, suppressScrollX: true },
    disabledEdit: true,
    headers: [
      {
        text: "Código Expediente",
        class: "sticky-header",
        value: "file_code",
        sortable: true,
      },
      {
        text: "Demandante",
        class: "sticky-header",
        value: "complaining_party",
        sortable: true,
      },
      {
        text: "Demandado",
        class: "sticky-header",
        value: "respondent_party",
        sortable: true,
      },
      {
        text: "Estudio a cargo",
        class: "sticky-header",
        value: "cargo_study.label",
        sortable: true,
      },
      {
        text: "Responsable",
        class: "sticky-header",
        value: "responsible",
        sortable: true,
      },
      {
        text: "Responsable Secundario",
        class: "sticky-header",
        value: "responsible",
        sortable: true,
      },
      {
        text: "Materia Convertida",
        class: "sticky-header",
        value: "controversial_matter",
        sortable: true,
      },
      {
        text: "Cuantía",
        class: "sticky-header",
        value: "amount",
        sortable: true,
      },
      {
        text: "Proyecto",
        class: "sticky-header",
        value: "project",
        sortable: true,
      },
      {
        text: "Estado",
        class: "sticky-header",
        value: "stage",
        sortable: false,
      },
      {
        text: "Acción",
        class: "sticky-header",
        value: "actions",
        sortable: false,
        width: 80,
      },
    ],
    selectedItem: null,
    cloneItem: null,
    typeDialog: "new",
    dialogNew: false,
    loadScroll: false,
    isFinishedScroll: false,
    // delete
    deleteIndex: 0,
    dialogDelete: false,
    // list
    listItem: [],
    loadData: false,
    metaData: {},
    noResult: false,
    filterData: "",
    paginationData: {},
    sortJudicialProcess: null,
    pages: 1,
    flagDelayScroll: false,
    totalCount: 0,
  }),
  computed: {
    ...mapState({
      listMasters: (state) => state.masters.listMasters,
      listSituations: (state) => state.masters.listSituations,
    }),
    configHeader() {
      if (this.roleUser === "visualizer" || this.roleUser === "executor") {
        const headTable = cloneDeep(this.headers);
        return headTable.splice(0, 4);
      }
      return this.headers;
    },
  },
  watch: {
    typeModule(val) {
      if (!this.isEmpty(val)) {
        this.clearScrollTopTable();
        this.flagDelayScroll = false;
        this.clearJudicialProcesses();
        const payload = `?response=lite&page=${this.pages}`;
        this.fetchJudicialProcesses(payload, true);
      }
    },
    typeSubmodule(val) {
      if (!this.isEmpty(val)) {
        this.clearScrollTopTable();
        this.flagDelayScroll = false;
        this.clearJudicialProcesses();
        const payload = `?response=lite&page=${this.pages}`;
        this.fetchJudicialProcesses(payload, true);
      }
    },
  },
  created() {
    this.fetchAllUsers();
  },
  mounted() {
    this.clearScrollTopTable();
    let query = "";
    if (this.fichaId) {
      query = `&search=${this.fichaId}`;
    }
    const payload = `?response=lite&page=${this.pages}${query}`;
    this.fetchJudicialProcesses(payload, true);
  },
  methods: {
    ...mapActions(["fetchAllUsers"]),
    onSearchFilter(payload, filterData) {
      this.listItem = [];
      this.filterData = filterData;
      this.pages = 1;
      this.noResult = false;
      this.fetchJudicialProcesses(payload, true);
    },
    fetchJudicialProcesses(payload, step = false) {
      if (step) {
        this.loadData = false;
      }
      this.axios
        .get(
          `/api/${this.apiByModule.module}/${this.apiByModule.submodule}${payload}`,
        )
        .then(({ data }) => {
          this.flagDelayScroll = true;
          this.loadScroll = false;
          this.pages = this.pages + 1;
          this.$refs.judicialDrawer.setLoadSearch(false);
          if (data.success) {
            this.metaData = data.metadata;
            this.paginationData = data.pagination;
            if (!this.isEmpty(data.data)) {
              this.noResult = false;
              this.listItem = uniqBy([...this.listItem, ...data.data], "id");
              this.totalCount = data.data.length;
              if (this.fichaId) {
                this.openDialogUpdate("edit", { id: this.fichaId });
              }
            } else {
              this.noResult = true;
              this.totalCount = 0;
            }
          } else {
            this.metaData = {
              total_situation_active: 0,
              total_situation_expired: 0,
              total_situation_in_process: 0,
            };
            this.listItem = [];
            this.noResult = true;
          }
          this.loadData = true;
          setTimeout(() => {
            this.flagDelayScroll = false;
          }, 500);
        });
    },
    scrollHanle() {
      if (!this.flagDelayScroll) {
        const { current_page, total_pages } = this.paginationData;
        if (this.loadData && current_page < total_pages) {
          this.loadData = true;
          let sortJudicialProcess = "";
          if (!this.isEmpty(this.sortJudicialProcess)) {
            sortJudicialProcess += `&sort=${this.sortJudicialProcess}`;
          }
          const payload = `?response=lite&page=${this.pages}${this.filterData}${sortJudicialProcess}`;
          this.flagDelayScroll = true;
          this.isFinishedScroll = false;
          this.loadScroll = true;
          this.fetchJudicialProcesses(payload, false);
        }
        if (current_page === total_pages) {
          this.isFinishedScroll = true;
          // setTimeout(() => {
          //   this.isFinishedScroll = false;
          // }, 3500);
        }
      }
    },
    onActiveNewItem(item) {
      if (item.id) {
        this.listItem.unshift(item);
        this.$nextTick(() => {
          const elem = document.getElementById(`${item.id}`);
          if (elem) {
            elem.classList.add("active-item");
            setTimeout(() => {
              elem.classList.remove("active-item");
            }, 8000);
          }
        });
      }
    },
    openDialogDelete(item, index) {
      this.deleteIndex = index;
      this.selectedItem = item;
      this.dialogDelete = true;
    },
    onSubmitDelete() {
      this.$refs.dialogDelete.toggleLoad(true);
      this.axios
        .delete(
          `/api/${this.apiByModule.module}/${this.apiByModule.submodule}/${this.selectedItem.id}/delete`,
        )
        .then(() => {
          this.$refs.dialogDelete.toggleLoad(false);
          this.listItem.splice(this.deleteIndex, 1);
          this.dialogDelete = false;
        })
        .catch(() => {
          this.$refs.dialogDelete.toggleLoad(false);
        });
    },
    openDialogUpdate(type = "add", item) {
      if (type === "add") {
        this.selectedItem = new IJudicialProcess();
        this.disabledEdit = false;
        this.dialogDraft = false;
        this.typeDialog = "new";
        this.dialogNew = true;
        this.$nextTick(() => {
          this.$refs.dialogDetailCard.clearErrors();
          this.$refs.dialogDetailCard.openDialogDetail();
        });
      } else {
        this.flagSelectDraft = false;
        this.typeDialog = "edit";
        this.$refs.dialogDetailCard.openDialogEdit(item);
        this.dialogNew = true;
      }
    },
    onCloseDetailCard() {
      this.selectedItem = new IJudicialProcess();
      this.$refs.dialogDetailCard.clearErrors();
    },
    reFetch(response) {
      if (response === 1) {
        const payload = `?response=lite&page=1`;
        this.axios
          .get(
            `/api/${this.apiByModule.module}/${this.apiByModule.submodule}${payload}`,
          )
          .then(({ data }) => {
            if (data.success) {
             this.$nextTick(() => {
               this.listItem = data.data;
             })
            }
            this.loadData = true;
          });
      }
    },
    setLoadScroll(flag) {
      this.loadScroll = flag;
    },
    setFinishedScroll(flag) {
      this.isFinishedScroll = flag;
    },
    clearJudicialProcesses() {
      this.filterData = "";
      this.sortJudicialProcess = null;
      this.loadData = false;
      this.noResult = false;
      this.pagination = {};
      this.metaData = {};
      this.pages = 1;
      this.listItem = [];
    },
  },
};
</script>
